import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { useConfigs } from './lib/config-context';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const renderDefaultEmptyMessage = () => /*#__PURE__*/_jsx(ResultsMessage, {
  illustration: "empty-state-charts",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customer-data-board.emptyText"
  })
});
const Empty = () => {
  const {
    renderEmpty = renderDefaultEmptyMessage
  } = useConfigs();
  return /*#__PURE__*/_jsx(Flex, {
    as: "div",
    flexGrow: 1,
    borderWidth: "100",
    borderBlockStartWidth: "0",
    borderStyle: "solid",
    borderColor: "border-core-subtle",
    children: /*#__PURE__*/_jsx(Box, {
      grow: 1,
      margin: "300",
      children: renderEmpty()
    })
  });
};
export default Empty;